import { Box } from '@mui/material';
import { type ComponentType, type SVGProps } from 'react';

import { LlmProvider } from 'llm-model-registry';

import { ReactComponent as BedrockSvg } from './assets/amazon.svg';
import { ReactComponent as ClaudeSvg } from './assets/anthropic.svg';
import { ReactComponent as DeepSeekSvg } from './assets/deepseek.svg';
import { ReactComponent as GeminiSvg } from './assets/google.svg';
import { ReactComponent as MetaSvg } from './assets/meta.svg';
import { ReactComponent as OpenAiSvg } from './assets/openai.svg';

const LLM_PROVIDER_LOGO_MAP: Record<LlmProvider, ComponentType<SVGProps<SVGSVGElement>>> = {
  [LlmProvider.OpenAI]: OpenAiSvg,
  [LlmProvider.Anthropic]: ClaudeSvg,
  [LlmProvider.Google]: GeminiSvg,
  [LlmProvider.Meta]: MetaSvg,
  [LlmProvider.Amazon]: BedrockSvg,
  [LlmProvider.DeepSeek]: DeepSeekSvg,
};

interface LlmProviderLogoProps {
  provider: LlmProvider;
  size?: number;
}

export function LlmProviderLogo(props: LlmProviderLogoProps) {
  const { provider, size = 16 } = props;
  const SvgComponent = LLM_PROVIDER_LOGO_MAP[provider];

  return (
    <Box
      component={SvgComponent}
      aria-hidden="true"
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        color: 'text.secondary',
      }}
    />
  );
}
